<div class="sidebar-header" *ngIf="isSideBar && title && title.length > 0">
  <h2>{{title}}<span *ngIf="selectedOptionCount > 0" class="font-14">({{selectedOptionCount}})</span></h2>
  <button class="close-sidebar" title="Close" (click)="sidebar.hide()">
    <svg><use xlink:href="#icon-cancel"></use></svg>
  </button>
</div>

<div [ngClass]="{ 'sidebar-content has-footer': isSideBar,'mt-3': title.length>20 }" *ngIf="visibleOptions && visibleOptions.length > 0">
  <section class="column-filter">
    <h3 *ngIf="!isSideBar && title" class="filter-title">{{title}}
      <button class="clear-section" (click)="clear()"><svg><use xlink:href="#icon-clear"></use></svg>Clear</button>
    </h3>
    <div class="form-check" *ngIf="isMeVisible">
      <input class="form-check-input" type="checkbox" (change)="meCheckboxChanged()" [id]="meId" type="checkbox" [(ngModel)]="isMeSelected">
      <label class="form-check-label" [attr.for]="meId">@Me</label>
    </div>
    <div  class="form-check" *ngFor="let option of visibleOptions">
      <input class="form-check-input" type="checkbox" (change)="checkboxChanged(option)" [id]="option.Id" type="checkbox" [(ngModel)]="option.IsChecked">
      <label class="form-check-label" [attr.for]="option.Id">{{option.DisplayName}}</label>
    </div>
    <div *ngIf="isSeeAllVisible">
      <a class="see-all" href="javascript:void(0)" (click)="seeAll()">See all</a>
    </div>
    <div *ngIf="areAllOptionsVisible">
      <a class="see-all" href="javascript:void(0)" (click)="seeLess()">See less</a>
    </div>
  </section>
</div>

<div class="sidebar-footer" *ngIf="isFooterVisible">
  <button class="btn-apply" (click)="apply()">Apply</button>
  <button class="btn-clear" (click)="clear()">Clear all</button>
</div>
